import React, {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmationDeleteDialog(props) {

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className='alert-description'>
            {`You have selected ${props.selected.length} subscription(s) for deletion. Are you sure you want to proceed? Selected subscription(s) will be PERMANENTLY DELETED.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" autoFocus onClick={props.handleDeleteSubscription}>YES</Button>
          <Button variant="outlined" color="primary" onClick={props.onClose} >
            NO
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}